import { render, staticRenderFns } from "./FollowingChefs.vue?vue&type=template&id=5e0ff91f&"
import script from "./FollowingChefs.vue?vue&type=script&lang=js&"
export * from "./FollowingChefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports